'use client';

import { useState } from 'react';
import { safeLocalStorage } from 'libs/utils/src/lib/storage/safeLocalStorage';

export type UseShallowAppearanceArgs = {
  closedStorageKey: string;
  preventOpeningStorageKey: string;
  expiration: number;
};

export const useShallowAppearance = ({
  closedStorageKey,
  preventOpeningStorageKey,
  expiration,
}: UseShallowAppearanceArgs) => {
  const [show, setShow] = useState(() => {
    const closed = Number(safeLocalStorage.getItem(closedStorageKey)) || 0;

    const preventOpening =
      safeLocalStorage.getItem(preventOpeningStorageKey) === 'true';

    const isNotExpired = Date.now() - expiration < closed;

    return !(preventOpening || isNotExpired);
  });

  const onClose = () => {
    safeLocalStorage.setItem(closedStorageKey, Date.now().toString());
    setShow(false);
  };

  const onPreventOpen = () => {
    safeLocalStorage.setItem(preventOpeningStorageKey, 'true');
  };

  return { show, setShow, onClose, onPreventOpen };
};
